import { translate } from './i18n.js';
import { getActiveLanguage } from './languageStore.js';
import { normalizeLanguageCode, resolveLanguage } from './localeManifest.js';

export const resolveCommunicationLanguage = (language, fallback = getActiveLanguage()) => (
  resolveLanguage(language, fallback)
);

export const translateCommunication = (language, key, params = {}) => translate(
  resolveCommunicationLanguage(language),
  key,
  { ...params, ns: 'communications' }
);

export const getCommunicationRecipientLabel = (recipient, language) => translateCommunication(
  language,
  `recipients.${recipient === 'expeditor' ? 'expeditor' : 'destinatar'}`
);

export const getBrowserNotificationFallbacks = (language) => ({
  newTitle: translateCommunication(language, 'browserNotification.newTitle'),
  newBody: translateCommunication(language, 'browserNotification.newBody'),
  systemTitle: translateCommunication(language, 'browserNotification.systemTitle'),
  driverStatusTitle: translateCommunication(language, 'browserNotification.driverStatusTitle'),
});

export const getBrowserNotificationTitle = (type, language) => {
  const fallbacks = getBrowserNotificationFallbacks(language);
  const normalizedType = String(type || '').trim().toLowerCase();

  if (['system_alert', 'system_message', 'system_notification'].includes(normalizedType)) {
    return fallbacks.systemTitle;
  }
  if (['driver_status_change', 'driver_update'].includes(normalizedType)) {
    return fallbacks.driverStatusTitle;
  }
  return fallbacks.newTitle;
};

export const getESignatureEmailDefaults = (language) => {
  const resolvedLanguage = resolveCommunicationLanguage(language);
  return {
    subject: translate(resolvedLanguage, 'email.defaultSubject', { ns: 'esignature' }),
    message: translate(resolvedLanguage, 'email.defaultMessage', { ns: 'esignature' }),
  };
};

// eSemneaza accepts one shared subject/body for the whole request. When every
// recipient selected the same language, use it; for a mixed-language request,
// keep the operator's active language as the deterministic shared fallback.
export const resolveSharedCommunicationLanguage = (recipients, fallbackLanguage) => {
  const recipientLanguages = new Set(
    (Array.isArray(recipients) ? recipients : [])
      .map((recipient) => normalizeLanguageCode(recipient?.language))
      .filter(Boolean)
  );

  return recipientLanguages.size === 1
    ? [...recipientLanguages][0]
    : resolveCommunicationLanguage(fallbackLanguage);
};
